module.exports = __webpack_public_path__ + "img/Group-1986.cf644310.png";